var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpilledOilVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1800_27227)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1800_27227)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1800_27227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4769 29.4469C56.4515 27.9534 55.3885 26.5824 53.7975 26.1605C53.5162 26.0861 53.2243 26.0522 52.9374 26H52.176C51.4822 26.0537 50.7885 26.0512 50.0947 26H39.3328C39.2412 26.0091 39.1496 26.0263 39.0581 26.0263C37.9976 26.0289 36.9366 26.0299 35.8761 26.0284C35.7759 26.0284 35.6763 26.0096 35.5766 26H31.5152C31.2751 26.0988 31.0127 26.1393 30.8128 26.3393C30.6734 26.4791 30.6287 26.669 30.5 26.8083V27.2631C30.7345 27.9037 31.2695 28.3175 31.6953 28.8103C32.4897 29.729 33.3071 30.6279 34.1194 31.5309C34.2231 31.6458 34.2618 31.7598 34.2618 31.9138C34.2577 36.1831 34.2582 40.4524 34.2597 44.7217C34.2603 46.2568 35.2088 47.492 36.6925 47.8982C36.9885 47.9792 37.2916 47.9929 37.5958 47.9929C41.0982 47.9944 44.6011 47.9827 48.1034 48C49.7061 48.0081 50.8714 46.9911 51.2661 45.8065C51.3866 45.4434 51.4227 45.0717 51.4227 44.6919C51.4217 39.5803 51.4232 34.4688 51.4237 29.3572C51.4237 28.9602 51.4222 28.9597 51.821 28.9622C52.1592 28.9647 52.498 28.9617 52.8362 28.9718C53.2939 28.9855 53.5493 29.2514 53.5498 29.7087C53.5508 31.9826 53.5493 34.2561 53.5508 36.53C53.5508 37.2811 53.9414 37.829 54.6189 38.0372C55.5121 38.3122 56.483 37.6259 56.4861 36.6971C56.4937 34.2804 56.5176 31.8631 56.4769 29.4469ZM36.5491 43.7803C36.5358 43.7803 36.5231 43.7823 36.5114 43.7838C36.5053 43.7843 36.4997 43.7853 36.4941 43.7863C36.4885 43.7873 36.4829 43.7884 36.4778 43.7899C36.4656 43.7924 36.4545 43.7965 36.4438 43.801C36.4377 43.8036 36.4316 43.8066 36.426 43.8096C36.4214 43.8122 36.4168 43.8152 36.4127 43.8187C36.4092 43.8208 36.4061 43.8238 36.4026 43.8274C36.399 43.8304 36.396 43.8339 36.3929 43.8375C36.3899 43.841 36.3873 43.8446 36.3848 43.8481C36.3797 43.8557 36.3751 43.8643 36.3715 43.8734L36.37 41.5565C36.3726 41.5732 36.3756 41.5874 36.3802 41.5995C36.3848 41.6122 36.3899 41.6228 36.397 41.6319C36.3995 41.636 36.4021 41.639 36.4051 41.642L36.4082 41.6451C36.4122 41.6486 36.4168 41.6522 36.4214 41.6557C36.4341 41.6638 36.4489 41.6699 36.4672 41.675C36.4738 41.6765 36.4809 41.678 36.4885 41.6795C36.5007 41.6816 36.515 41.6836 36.5302 41.6846C36.5394 41.6856 36.5491 41.6866 36.5597 41.6871H36.5602C36.5674 41.6876 36.575 41.6881 36.5826 41.6881C36.6208 41.6897 36.666 41.6902 36.7194 41.6907C37.6329 41.6973 38.5469 41.6856 39.4599 41.715C39.994 41.7322 40.3922 42.1915 40.3983 42.7213C40.4049 43.2996 39.9395 43.7737 39.3358 43.7792C38.4223 43.7879 37.5083 43.7858 36.5948 43.7792C36.5786 43.7792 36.5633 43.7792 36.5491 43.7803ZM36.367 37.313C36.368 37.3185 36.369 37.3236 36.37 37.3287C36.3715 37.3352 36.3726 37.3413 36.3746 37.3469C36.3853 37.3879 36.4031 37.4203 36.429 37.4446C36.4331 37.4492 36.4382 37.4532 36.4433 37.4573C36.4778 37.4841 36.5246 37.4988 36.5842 37.5029C36.5938 37.5034 36.604 37.5039 36.6142 37.5039C36.6228 37.5039 36.6315 37.5039 36.6406 37.5034C36.7083 37.5003 36.7759 37.5034 36.8435 37.5034C37.6894 37.5044 38.5362 37.4836 39.3811 37.514C40.0153 37.5373 40.4192 38.0032 40.3968 38.6034C40.3759 39.1691 39.9116 39.5884 39.2951 39.5899C38.3898 39.593 37.4849 39.5945 36.5796 39.5884C36.5689 39.5884 36.5587 39.5884 36.5491 39.5889C36.5363 39.5889 36.5241 39.5899 36.5124 39.5909C36.5073 39.5915 36.5028 39.592 36.4982 39.593C36.4956 39.593 36.4936 39.5935 36.4916 39.5935C36.485 39.5945 36.4784 39.596 36.4723 39.5975C36.4677 39.5985 36.4636 39.5996 36.4595 39.6011C36.4468 39.6051 36.4351 39.6102 36.425 39.6168C36.4194 39.6198 36.4148 39.6239 36.4102 39.6279C36.3955 39.6416 36.3843 39.6593 36.3771 39.6821C36.3751 39.6877 36.3736 39.6932 36.3726 39.6988C36.371 39.7044 36.37 39.71 36.369 39.716L36.367 37.313ZM40.3932 34.5057C40.3174 35.0198 39.8734 35.3961 39.3282 35.3981C38.4228 35.4016 37.5175 35.4042 36.6121 35.3951C36.5857 35.3945 36.5618 35.3956 36.5404 35.3976C36.5323 35.3981 36.5246 35.3991 36.517 35.4001C36.5094 35.4011 36.5023 35.4021 36.4951 35.4037C36.4712 35.4082 36.4514 35.4158 36.4341 35.4259C36.4285 35.4295 36.4234 35.433 36.4188 35.4366L36.4178 35.4376C36.4133 35.4411 36.4092 35.4452 36.4056 35.4492C36.4046 35.4497 36.4041 35.4508 36.4031 35.4518C36.401 35.4548 36.3985 35.4579 36.3965 35.4609C36.3939 35.4639 36.3919 35.4675 36.3899 35.471C36.3838 35.4806 36.3792 35.4918 36.3751 35.5039C36.3715 35.5156 36.3685 35.5282 36.3665 35.5419C36.3665 35.5429 36.366 35.5439 36.366 35.545L36.3644 33.0998C36.3649 33.1095 36.366 33.1186 36.367 33.1272C36.368 33.1368 36.369 33.1459 36.371 33.1545C36.3731 33.1662 36.3756 33.1773 36.3792 33.1875C36.3802 33.193 36.3822 33.1981 36.3843 33.2032C36.3873 33.2113 36.3904 33.2189 36.3944 33.2254C36.398 33.2325 36.4016 33.2386 36.4061 33.2447C36.4061 33.2457 36.4077 33.2472 36.4087 33.2482C36.4122 33.2533 36.4163 33.2579 36.4209 33.2619C36.4219 33.2634 36.4229 33.2644 36.4234 33.2644C36.4275 33.269 36.4321 33.2731 36.4372 33.2766C36.4387 33.2786 36.4402 33.2796 36.4417 33.2801C36.4458 33.2832 36.4504 33.2862 36.455 33.2888C36.4575 33.2903 36.4595 33.2918 36.4616 33.2923C36.4677 33.2958 36.4738 33.2989 36.4809 33.3014C36.488 33.3045 36.4951 33.307 36.5033 33.309C36.5048 33.31 36.5063 33.31 36.5079 33.3105C36.5155 33.3126 36.5236 33.3146 36.5318 33.3161C36.5333 33.3166 36.5343 33.3166 36.5353 33.3166C36.543 33.3181 36.5511 33.3191 36.5592 33.3201C36.5725 33.3222 36.5862 33.3232 36.6004 33.3237C36.6121 33.3242 36.6243 33.3247 36.6376 33.3247H36.6554C37.5012 33.3105 38.347 33.3181 39.1934 33.3222C39.3434 33.3227 39.4945 33.309 39.6445 33.3597C40.1577 33.5334 40.4675 34.0023 40.3932 34.5057Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1800_27227",
    x: 0.5,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1800_27227",
    x: 24.5,
    y: 24,
    width: 38,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1800_27227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1800_27227",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1800_27227",
    x1: 43.5,
    y1: 12,
    x2: 43.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpilledOilVolume);
export default __webpack_public_path__ + "static/media/SpilledOilVolume.8aad33ad0fb83cdff58ed442b9f2ee00.svg";
export { ForwardRef as ReactComponent };